import styled from "styled-components";
import { Card as RBCard } from "react-bootstrap";

export const StyledCustomCard = styled(RBCard)`
  border: none !important;
  // border-bottom: 1px solid color-mix(in srgb, var(--LightGray), transparent 50%) !important;

  // update border css for separation
  border-bottom: 2px solid color-mix(in srgb, var(--LightGray), transparent 50%) !important;


  background-color: transparent;
  border-radius: 0 !important;

  color: ${({ theme }) => theme?.colors?.font || "#111"} !important;

  .bank-title,
  .apy-value,
  .est-earnings,
  .badge {
    /* add styles here if needed for badge */
  }

  @media (max-width: 27rem) { 
    &:first-child {
      border-top: 1px solid color-mix(in srgb, var(--LightGray), transparent 50%) !important;
      padding-top: 0.5rem !important
    }
      padding-bottom: 0.5rem !important;
  }
  // @media (max-width: 27rem) { 
  //   &:first-child {
  //     border-top: 1px solid color-mix(in srgb, var(--LightGray), transparent 50%) !important;
  //     padding-top: 1rem !important
  //   }
  //     padding-bottom: 1rem !important;
  // }
`;
